<script lang="ts">
  let {
    icon = "📭",
    title = "Nada por aqui ainda",
    description = "",
    actionLabel,
    onAction,
  } = $props<{
    icon?: string;
    title?: string;
    description?: string;
    actionLabel?: string;
    onAction?: () => void;
  }>();
</script>

<div class="card text-center py-10">
  <div class="text-5xl mb-3" aria-hidden="true">{icon}</div>
  <h3 class="text-lg font-semibold mb-1">{title}</h3>
  {#if description}
    <p class="text-muted text-sm max-w-md mx-auto mb-4">{description}</p>
  {/if}
  {#if actionLabel && onAction}
    <button class="btn-primary" onclick={onAction}>{actionLabel}</button>
  {/if}
</div>
